import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';

export default function AdBlockDetector() {
  const [isAdBlockDetected, setIsAdBlockDetected] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const detectAdBlock = async () => {
      try {
        const response = await fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
          method: 'HEAD',
          mode: 'no-cors'
        });
      } catch (error) {
        setIsAdBlockDetected(true);
      }
    };

    detectAdBlock();

    // Check periodically
    const interval = setInterval(detectAdBlock, 5000);
    return () => clearInterval(interval);
  }, []);

  if (!isAdBlockDetected || !isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      >
        <div className="bg-white rounded-xl shadow-2xl p-8 max-w-lg mx-4 relative">
          <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
            <div className="bg-red-100 rounded-full p-4">
              <AlertTriangle size={40} className="text-red-600" />
            </div>
          </div>

          <div className="text-center mt-4">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Ad Blocker Detected</h3>
            <div className="space-y-4 text-gray-600">
              <p>
                We've detected that you're using an ad blocker. Our website relies on 
                advertisements to keep providing free name meanings and matches.
              </p>
              <p className="font-medium">
                Please disable your ad blocker to support us and enjoy all features!
              </p>
            </div>

            <div className="mt-8 space-x-4">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
              >
                I've Disabled Ad Blocker
              </button>
              <button
                onClick={() => setIsVisible(false)}
                className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
              >
                Continue with Ad Blocker
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}